import { useRequest } from 'ahooks';
import { useState } from 'react';
import {
  getAcctBalService,
  getBillAmountService,
  getBizCustByCustCodeService,
  getCreditService,
  getDepartmentInfoService,
  getMemberListQtyService,
  getOrderListQtyService,
  getServiceChargesService,
  getSubsStatisticsService,
  getTicketStatisticsService,
  updateBizCustInfoService,
  getYearlyFlowService
} from './services';

export default function OverViewModel() {
  const [payLoading, setPayLoading] = useState<boolean>(false); // 支付页面加载状态
  const [paymentLoading, setPaymentLoading] = useState(false); // 控制支付按钮

  const { data: custData, run: queryBizCustByCustCode } = useRequest(
    getBizCustByCustCodeService,
    {
      manual: true,
    },
  );

  const { data: departmentInfoData, run: queryDepartmentInfo } = useRequest(
    getDepartmentInfoService,
    {
      manual: true,
    },
  );

  const {
    data: memberListQtyData,
    run: queryMemberListQty,
    mutate: mutateMemberListQtyData,
  } = useRequest(getMemberListQtyService, {
    manual: true,
  });

  const {
    data: ticketStatisticsQtyData,
    run: queryTicketStatistics,
    mutate: mutateTicketStatisticsQtyData,
  } = useRequest(getTicketStatisticsService, {
    manual: true,
  });

  const {
    data: subsStatisticsQtyData,
    run: querySubsStatistics,
    mutate: mutateSubsStatisticsQtyData,
  } = useRequest(getSubsStatisticsService, {
    manual: true,
  });

  const { data: orderListQtyData, run: queryOrderListQty } = useRequest(
    getOrderListQtyService,
    {
      manual: true,
    },
  );

  const { loading: uploadLoading, runAsync: submitBizCustInfo } = useRequest(
    updateBizCustInfoService,
    {
      manual: true,
    },
  );

  const {
    data: creditData,
    run: queryCredit,
    mutate: mutateCreditData,
  } = useRequest(getCreditService, {
    manual: true,
    onError: () => {
      mutateCreditData((prev:any) => {
        return {
          ...prev,
          result: 0,
          currentBalance: 0,
          totalAmount: 0,
        }
      }); // 接口报错时，清空数据，兼容显示饼图
    },
  });

  const {
    data: billAmountData,
    run: queryBillAmount,
    mutate: mutateBillAmountData,
  } = useRequest(getBillAmountService, {
    manual: true,
    onError: () => {
      mutateBillAmountData(null); // 接口报错时，清空数据
    },
  });

  const {
    data: serviceChargesData,
    run: queryServiceCharges,
    mutate: mutateServiceChargesData,
  } = useRequest(getServiceChargesService, {
    manual: true,
    onError: () => {
      mutateServiceChargesData(null); // 接口报错时，清空数据
    },
  });

  const {
    data: acctBalData,
    run: queryAcctBal,
    mutate: mutateAcctBalData,
  } = useRequest(getAcctBalService, { manual: true });


  const {
    data: yearlyFlowData,
    run: queryYearlyFlow,
    mutate: mutateYearlyFlowData,
  } = useRequest(getYearlyFlowService, { manual: true });

  return {
    custData,
    departmentInfoData,
    memberListQtyData,
    orderListQtyData,
    uploadLoading,
    creditData,
    billAmountData,
    serviceChargesData,
    acctBalData,
    queryAcctBal,
    queryBizCustByCustCode,
    queryDepartmentInfo,
    queryMemberListQty,
    queryOrderListQty,
    submitBizCustInfo,
    queryCredit,
    queryBillAmount,
    queryServiceCharges,
    mutateCreditData,
    mutateMemberListQtyData,
    mutateServiceChargesData,
    mutateAcctBalData,
    mutateBillAmountData,
    payLoading,
    setPayLoading,
    paymentLoading,
    setPaymentLoading,
    subsStatisticsQtyData,
    mutateSubsStatisticsQtyData,
    querySubsStatistics,
    ticketStatisticsQtyData,
    queryTicketStatistics,
    mutateTicketStatisticsQtyData,
    yearlyFlowData,
    queryYearlyFlow,
    mutateYearlyFlowData,
  };
}
